module.exports = __webpack_public_path__ + "img/face.243cffe8.jpg";